import React, { useRef, useEffect } from "react";
import QRCode from 'react-qr-code';
import html2canvas from "html2canvas";  
import styles from "./index.module.css";
import Logo from "../../../../../assets/images/brand/IBSC.png";
import Stamp from "../../../../../assets/images/brand/star-stamp.png";
import Seal from "../../../../../assets/images/brand/Seal-removebg-preview.png";

const QR_Link = process.env.REACT_APP_PUBLIC_QR_LINK;

const formatDateWithSuperscript = (dateString) => {
    if (!dateString) return '';

    const parts = dateString.split(' ');

    if (parts.length < 3) return dateString;

    let day = parts[0].match(/\d+/)[0];
    const suffix = parts[0].replace(/\d+/, '');
    const month = parts[1];
    const year = parts[2];

    day = day.padStart(2, '0');

    return { day, suffix, month, year };
};

const splitTextAndDate = (input = "") => {
    const text = normalizeInput(input);

    const dateRegex = /(\d{1,2})(st|nd|rd|th)\s+([A-Za-z]+)\s+(\d{4})/i;
    const match = text.match(dateRegex);

    if (!match) {
        return {
            prefixText: text,
            day: null,
            suffix: null,
            month: null,
            year: null,
        };
    }

    const [fullDate, day, suffix, month, year] = match;

    const prefixText = text.replace(fullDate, "").trim();

    return {
        prefixText,
        day,
        suffix,
        month,
        year,
    };
};

const normalizeInput = (text = "") => {
    return text
        .replace(/[\u0000-\u001F\u007F-\u009F]/g, "") // control chars
        .replace(/ᵗʰ/g, "th")
        .replace(/ˢᵗ/g, "st")
        .replace(/ⁿᵈ/g, "nd")
        .replace(/ʳᵈ/g, "rd")
        .trim();
};

const IBSCOfficialCertificateImage = ({ data, onImageGenerated }) => {
    const certificateRef = useRef(null);
    const formattedDate = formatDateWithSuperscript(data?.completion_date);
    const formattedCertificateDate = formatDateWithSuperscript(data?.issued_date);

    const { prefixText, day, suffix, month, year } =
        splitTextAndDate(data?.completion_date);

    useEffect(() => {
        const generateImage = async () => {
            if (!certificateRef.current) return;

            const canvas = await html2canvas(certificateRef.current, {
                scale: window.devicePixelRatio,
                useCORS: true,
                logging: false,
            });

            const imgData = canvas.toDataURL("image/jpeg", 1.0);

            if (onImageGenerated) {
                onImageGenerated(imgData);
            }
        };

        setTimeout(generateImage, 500);
    }, []);

    return (
        // <div className={`main-card`}>
        <div ref={certificateRef} className={styles.certificateContainer} style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
            <img src={Logo} alt="Logo" className={styles.logo} />
            <p  className={styles.text}>This is to certify that</p>
            <p className={styles.studentName}>{data?.student_name}</p>
            <p className={styles.textSentence}>
            having fulfilled the conditions prescribed by the institute is
            </p>
            <p className={styles.textSentence}>
            admitted to the
            </p>
            <h3 className={styles.courseName}>{data?.course_batch?.course.name}</h3>
            <p className={styles.textSentence}>This certificate is awarded under the common seal of the</p>
            <p className={styles.textSentence}>IBS College of TVET</p>
            <p className={styles.textSentence}>on {formattedCertificateDate.day}<span className={styles.superScript}>{formattedCertificateDate.suffix}</span> {formattedCertificateDate.month} {formattedCertificateDate.year}</p>
            {/* <p className={styles.textSentence}>{data?.issued_date}</p> */}
            {/* Footer with Signatures, Stamp, and QR */}
            <div className={styles.footer}>
                <div className={styles.sealContainer}>
                    <img src={Seal} alt="Seal" className={styles.sealImg} />
                    <p className={styles.signature}>ACADEMIC COORDINATOR</p>
                    <p className={styles.signatureBottom}>HEAD OF COLLEGE</p>
                </div>
                <img src={Stamp} alt="Stamp" className={styles.stamp} />
                <div style={{ textAlign: "center" }}>
                    <QRCode
                        value={`${QR_Link}document_ref/${data?.document_ref}`}
                        size={70}
                        className="code"
                    />
                    <p className={styles.qrText}>Scan to verify certificate.</p>
                    <p className={styles.detailsText}>Document Ref: {data?.document_ref}</p>
                    <p className={styles.detailsText}>Completion Date: {formattedDate.day} {formattedDate.month} {formattedDate.year}</p>
                    {/* <p className={styles.detailsText}>Completion Date: {data?.completion_date}</p> */}
                    <p className={styles.refText}>NTC REG#: 010</p>
                </div>
            </div>
        </div>
        // </div>
    );
};

export default IBSCOfficialCertificateImage;